import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-route-schedule-diff-confirm',
  templateUrl: './route-schedule-diff-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RouteScheduleDiffConfirmComponent {
  changes: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { changes: string[] },
    private dialogRef: MatDialogRef<RouteScheduleDiffConfirmComponent>,
  ) {
    this.changes = data?.changes || [];
  }

  confirm() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
